import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AdminService } from "../admin.service";

@Component({
  selector: "app-admin-add-gps-type",
  templateUrl: "./admin-add-gps-type.component.html",
  styleUrls: ["./admin-add-gps-type.component.css"],
})
export class AdminAddGpsTypeComponent implements OnInit {
  gpsTypeForm: FormGroup;
  loading: boolean = false;
  token: any;

  constructor(
    private matdialogref: MatDialogRef<AdminAddGpsTypeComponent>,
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private snackBar: MatSnackBar,
    private service: AdminService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    this.gpsTypeForm = this.formBuilder.group({
      server_name: [
        "",
        [Validators.required, Validators.pattern("^[a-zA-Z][a-zA-Z\\s]+$")],
      ],
      server_url: ["", Validators.compose([Validators.required])],
      server_token: ["", Validators.compose([Validators.required])],
    });
    if (this.data.data) {
      this.gpsTypeForm.patchValue(this.data.data);
    }
  }

  public get GpsTypeFormControl() {
    return this.gpsTypeForm.controls;
  }

  public close() {
    this.matdialogref.close();
  }

  public AddGpsType() {
    if (this.gpsTypeForm.valid) {
      this.loading = true;
      this.service.PostGPSType(this.gpsTypeForm.value, this.token).subscribe(
        (response: any) => {
          if (
            (response.status == 201 && response.status == 200) ||
            response.body.data
          ) {
            this.snackBar.open("Server Added Successfully", "Success", {
              duration: 5000,
            });
            this.matdialogref.close({ event: "Success" });
          }
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
      this.loading = false;
    } else {
      this.snackBar.open("Please Enter valid GPS Type Data", "Fail", {
        duration: 5000,
      });
    }
  }

  public EditGpsType() {
    if (this.gpsTypeForm.valid) {
      this.loading = true;
      this.service
        .UpdateGPSType(this.gpsTypeForm.value, this.token, this.data.data._id)
        .subscribe(
          (response: any) => {
            if (
              (response.status == 201 && response.status == 200) ||
              response.body.data
            ) {
              this.snackBar.open("Server Edited Successfully", "Success", {
                duration: 5000,
              });
              this.matdialogref.close({ event: "Success" });
            }
          },
          (error) => {
            if (error.error.message === "jwt malformed") {
              this.router.navigateByUrl("admin/login");
              window.localStorage.clear();
            }
            if (error.error.message === "jwt expired") {
              this.router.navigateByUrl("admin/login");
              window.localStorage.clear();
            }
            if (error.error.message === "invalid signature") {
              this.router.navigateByUrl("admin/login");
              window.localStorage.clear();
            }
            this.snackBar.open(error.error.message, "Fail", {
              duration: 5000,
            });
          }
        );
      this.loading = false;
    } else {
      this.snackBar.open("Please Enter valid Document Data", "Fail", {
        duration: 5000,
      });
    }
  }
}
